import styled from 'styled-components';

export const PageStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 22px;
    margin-bottom: 0;
  }

  h3 {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-weight: lighter;
    text-align: center;
    font-size: 17px;
    margin-bottom: 30px;
    max-width: 90%;
  }

  img {
    max-width: 90%;
    margin-top: 8vh;
  }
`;
